import { createAction } from 'redux-actions';
import * as C from '../constants';

export const reportPageUpdateKeyword = createAction(
  C.ACTION_TYPES.REPORT_PAGE_UPDATE_KEYWORD,
  (keyword: string) => ({ keyword })
);



// WEBPACK FOOTER //
// ./app/actions/ReportPageActionCreators.ts